module.exports = __webpack_public_path__ + "media/images/search-2f3f181ecfae283e525b8849e202dda3.svg";